import EventIcon from '@mui/icons-material/Event';

import EventList from './EventList';
import EventCreate from './EventCreate';
import EventEdit from './EventEdit';

const events = {
	list: EventList,
	create: EventCreate,
	edit: EventEdit,
	icon: EventIcon
};

export default events
